import React, {createRef, useState} from "react";
import { useSelector } from 'react-redux';
import { selectCurrentUser } from './../redux/user/userSlice';
import {editMyProfil, getAuthorFeed} from "../api";
import {PostList} from '../post/postList';
import { Link } from 'react-router5';
import {useTranslation} from "react-i18next";
import {toRichText} from "../utils/text";
import Loader from "../utils/loader";
import resizeImage from "./image_resize_helper";

import './style/profilUser.css';

const profile_img_max_width = 150,
      profile_img_max_height = 150;

const fileToBase64 = (file, cb) => {
  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    cb(reader.result)
  };
  reader.onerror = function (error) {
    console.log('Error: ', error);
  };
}

const handleImage = (file, cb) => {
  return fileToBase64(file, (data_uri) => {
    return resizeImage(data_uri, profile_img_max_width, profile_img_max_height, cb)
  })
}


function ProfilUser({dataList, bookmarksInit, route,users}) {
  const { t } = useTranslation();
  const { user } = useSelector(selectCurrentUser);
  const [openModal,setOpenModal] = useState(false);

  let user_img;

  if(user.img === undefined || user.img === null){
    user_img = <span className="c-profil_img-replace">{user.firstname[0].toUpperCase()}{user.lastname[0].toUpperCase()}</span>
  }else{
    user_img = <img alt="" className="c-profil_img" style={{width: "50px", height: "50px"}} src={user.img} />
  }

  return(
    <>
      <div className="c-profil_resume">
        <div className="c-resume_img">
          { user_img }
          <div className="c-img_buttons">
            <span onClick={()=>{setOpenModal(true)}} className="c-button_edit" />
            <Link className="c-button_settings" href="" routeName={"settings"} routeOptions={{reload: true}}></Link>
          </div>
        </div>
        <div className="c-resume_infos">
          <span className="c-infos_name">{user.firstname} {user.lastname} - {t('Mon Profil')}</span>
          <p className="c-infos_bio">{toRichText(user.biography)}</p>
          <span className="c-infos_mail">{user.email}</span>
        </div>
        <div className="c-resume_buttons">
          <Link className={`c-focus ${route === "focus" ? "active" : ""}`} href="" routeName={"profile.focus"} routeOptions={{reload: false}}>{t('Mes focus')}</Link>
          <Link className={`c-bookmark ${route === "bookmark" ? "active" : ""}`} href="" routeName={"profile.bookmark"} routeOptions={{reload: false}}>{t('Mes signets')}</Link>
        </div>
      </div>
      <div className="c-profil_authorFeed">
        <UserPostFeed users={users} user={user} bookmarks={bookmarksInit}/>
      </div>
      { openModal && <UserModalEdit setOpenModal={setOpenModal} user={user} />}
    </>
  )
}

const UserModalEdit = ({user,setOpenModal})=>{
  const { t } = useTranslation();
  const [u, setU] = useState(user);
  const inputFileRef  = createRef();
  const [in_flight, setInFlight] = useState(false);
  const [error, setError] = useState(false);


  const handleInputChange = (e) => {
    setU({...u, [e.target.name]: e.target.value});
  }

  const onSelectedFile = (e) => {
    const file = e.target.files[0];

    handleImage(file, (data_uri_scheme) => {
      setU({...u, img: data_uri_scheme});
    });
  }


  const updateProfil = () =>{
    let data = {...u};

    if (!inputFileRef.current.files[0]) {
      // if no image was picked, don't reupload the same image!
      delete data.img;
    } else {
      // get rid of header of data uri scheme (data:image/jpeg;base64,/9j/4AAQSk...)
      data.img = data.img.slice(data.img.indexOf(',') + 1);
    }

    // redirects after upload
    setInFlight(true);
    setError(false);
    editMyProfil(data).then(() => {
      window.location.href = window.location.pathname;
    }, () => {
      setError(t("An error occured"));
      setInFlight(false);
    });
  }

  return (
      <div className={'ModalEditUser'}>
        <div className={'ModalEditUserContainer'}>
        { in_flight && <div className="ModalEditUserLoader" ><Loader /></div>}
        <div className={'ModalEditTopContainer'}>
          <div className={'ModalEditTopLeftContainer'}>
            <div onClick={()=>{setOpenModal(false)}} className={'ModalEditClose'}></div>
            <div className={'ModalEditTitle'}>{t('Editer mon profil')}</div>
          </div>
          <div className={'ModalEditValider'} onClick={updateProfil}>{t('Valider')}</div>
        </div>
        <div className={'ModalEditMainContainer'}>
          { error && <div className="error">{ error }</div> }
          <div className={'ModalEditImgProfilContainer'}>
            <img alt={u.firstname} src={u.img} className={'ModalEditImgProfil'} />
            <input className={'modalEditInputFile'} onChange={onSelectedFile} type={'file'} name={'img'} ref={inputFileRef}/>
            <div className={'ModalEditImgProfilCameraContainer'} onClick={() => { inputFileRef.current.click() }}>
              <div className={'ModalEditImgProfilCamera'}></div>
            </div>
          </div>
          <div className={'ModalEditInputContainer ModalEditName'}>
            <label className={'ModalEditLabel'}>{t('Nom')}</label>
            <input onChange={handleInputChange} type={'text'} className={'ModalEditInput'} name={'lastname'} value={u.lastname}/>
          </div>
          <div className={'ModalEditInputContainer ModalEditName'}>
            <label className={'ModalEditLabel'}>{t('Prénom')}</label>
            <input onChange={handleInputChange} type={'text'} className={'ModalEditInput'} name={'firstname'} value={u.firstname}/>
          </div>
          <div className={'ModalEditInputContainer ModalEditName'}>
            <label className={'ModalEditLabel'}>{t('E-mail')}</label>
            <input onChange={handleInputChange} type={'email'} className={'ModalEditInput'} name={'email'} value={u.email}/>
          </div>
          <div className={'ModalEditInputContainer ModalEditBio'}>
            <label className={'ModalEditLabel'}>{t('Bio')}</label>
            <textarea onChange={handleInputChange}  className={'ModalEditInput ModalEditTextArea'} name={'biography'} value={u.biography} />
          </div>
        </div>
        </div>
      </div>
  )
}

const UserPostFeed = ({user,users, bookmarks}) => {
  const { t } = useTranslation();

  const [posts,setPosts] = React.useState([]);
  const [cursor,setCursor] = useState('');

  const [init, setInit] =  useState(false);


  const uniqueArray = (arr1,arr2)=>{
    let ids  = arr1.map((item)=>{return item.id});
    return  arr2.filter((item) =>{return !ids.includes(item.id);});
  }

  if(!init){
    setInit(true);
    getUserFeed();
  }

  function getUserFeed(){
    if(cursor!==false){
      getAuthorFeed(user.id, cursor).then(data=>{
        const newList = posts.concat(uniqueArray(posts,data.data));
        setCursor(data.cursor);
        setPosts(
          newList);
      });
    }
  }


  return (
    <>
    <div className="c-authorFeed_top">
      <div className="c-top_infos">
        <p>{t('Mes contenus')}</p>
      </div>
      <div className="c-top_filter">
        <span className="c-filter_number">{posts.length}</span>
      </div>
    </div>
    <div className="c-authorFeed_post">
      {posts.length>0 && <PostList users={users} apiCall={getUserFeed} bookmarks={bookmarks} posts={posts} cursor={cursor}/>}

    </div>
  </>
  )
}

export default ProfilUser
